<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Coberturas do Endosso
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          TIPO DE ENDOSSO
          <p>{{ getTipoEndosso(this.idTipoEndosso) }}</p>
        </v-flex>
        <v-flex row wrap> CÓD. COTAÇÃO ENDOSSO </v-flex>
        <v-flex> N. PROPOSTA / ENDOSSO </v-flex>
        <v-flex>DIAS DE VIGÊNCIA ENDOSSO </v-flex>
        <v-flex>RAZÃO SOCIAL </v-flex>
        <v-flex> CNPJ </v-flex>
        <v-flex> QTD. ÍTENS INCLUSÃO </v-flex>
        <v-flex> VLR.ENDOSSO </v-flex>
        <v-flex> </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            @click="abrirModalCobertura()"
            v-if="selected.length == 1 && idTipoEndosso == 3"
            color="error"
            round
          >
            Remover Coberturas
          </v-btn>
        </v-card-title>
      </v-card>
      <template>
        <div class="table-width">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="veiculoList"
            :pagination.sync="pagination"
            :total-items="pagination.totalItems"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td
                v-if="!camposDisabled"
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <v-checkbox
                  class="checkbox"
                  color="primary"
                  :input-value="props.selected"
                  primary
                  hide-details
                  :disabled="camposDisabled"
                ></v-checkbox>
              </td>
              <td
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                :class="[' themeGrey--text click', ...(atributos.class || [])]"
              >
                {{ texto }}
              </td>
            </template>
          </v-data-table>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
        <v-btn
        color="secondary"
        elevation="2"
        max-width="121px"
        width="100"
        right
        @click="totaisCalculados"
        >{{recalcular ? "Calcular" : "Ver Calculo"}}</v-btn
      >
    </v-layout>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogCalculo" max-width="1200px">
          <ModalDeCalculo
            v-if="dialogCalculo"
            :dialog="dialogCalculo"
            :resultados="resultados"
            :statusProposta="camposDisabled"
            :camposInfoGerais="camposInfoGerais"
            @ativarLoader="loaderPagina = true"
            @desativarLoader="loaderPagina = false"
            @fechar="dialogCalculo = false"
          />
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog
          persistent
          v-model="modalCobertura"
          max-width="600px"
          max-height="300px"
        >
          <template>
            <v-card class="dialog">
              <v-card-title class="primary">
                <span class="headline">
                  <div style="font-size: 16px;">
                    Coberturas do Veículo: placa {{ buscarPlaca() }}
                  </div></span
                >
              </v-card-title>
              <v-card class="pa-4">
                <div class="textlabel">
                  <v-layout style="font-size: 15px">
                    <div>REMOVER</div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div>COBERTURAS</div>
                  </v-layout>
                </div>
                <v-flex
                  v-for="item in loadCoberturasByItemSelected()"
                  :key="item.id"
                >
                  <v-layout>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    <v-checkbox
                      color="primary"
                      v-model="coberturaExcluirList"
                      :value="item.id"
                    >
                      <template v-slot:label>
                        <div
                          style="font-size: 14px;"
                          :class="
                            coberturaAdicionadaAExclusao(item.id) == true
                              ? 'textred'
                              : 'textblack'
                          "
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {{ item.text }}
                        </div>
                      </template>
                    </v-checkbox>
                  </v-layout>
                </v-flex>
                <v-spacer></v-spacer>
                <template>
                  <v-card-actions class="px-2 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="cancelar()" flat>
                      Cancelar
                    </v-btn>
                    <v-btn class="button-permanecer" flat @click="salvar()"
                      >Salvar
                    </v-btn>
                  </v-card-actions>
                </template>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-dialog
        persistent
        v-model="loaderPagina"
        width="500"
        content-class="elevation-0"
      >
        <v-card>
          <v-container style="background-color: #FFF;height: 100px;">
            <v-layout
              row
              wrap
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-flex md12 class="text-subtitle-1 text-center">
                <p
                  style="font-weight: bold; margin-bottom: 0; text-align: center"
                >
                  Processando, aguarde...
                </p>
              </v-flex>
              <v-flex md12>
                <v-progress-linear
                  :indeterminate="true"
                  color="primary"
                  height="6"
                  value="15"
                ></v-progress-linear>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalDeCalculo from "./ModalDeCalculo.vue";

export default {
  name: "CoberturaEndossoExclusao",
  components: {
    ModalDeCalculo
  },
  data() {
    return {
      recalcular: false,
      loaderPagina: false,
      idRascunhoEndosso: null,
      itensSalvar: [],
      listaIdItem: [],
      dateInicio: null,
      idMotivoEndosso: null,
      textoLivreEndosso: null,
      item: [],
      valor: [],
      coberturaExcluirList: [],
      coberturasItens: [],
      dadosItem: {},
      itemModificadoList: [],
      resultados: {
        totalAp: null,
        totalCoberturaCompensativa: null,
        totalCoberturaRcf: null,
        totalCoberturasAdicionais: null,
        totalFranquiaCoberturaAcessorios: null,
        totalFranquiaCoberturaCarroceria: null,
        totalFranquiaCoberturaCompensativa: null,
        totalFranquiaCoberturaEquipamentos: null,
        totalPremio: null,
        totalServicosAgregados: null,
        totalRestituicao: null
      },
      cobertura: null,
      veiculoList: [],
      veiculoRemovidoList: [],
      idApolice: null,
      idTipoEndosso: null,
      modalCobertura: false,
      menu: false,
      filtrarErros: false,
      itemSelecionado: [],
      simOuNao: [
        {
          id: true,
          titulo: "Sim"
        },
        {
          id: false,
          titulo: "Não"
        }
      ],
      headers: [
        { text: "", align: "center", value: "", sortable: false },
        { text: "ITEM", align: "center", value: "item", class: "item-primary" },
        {
          text: "PLACA",
          align: "center",
          value: "placa"
        },
        { text: "TIPO DE COBERTURA", align: "center", value:"tipoCobertura" },
        { text: "TIPO DE CONTRATAÇÃO", align: "center", value:"tipoDeContratacao" },
        { text: "% AJUSTE VMR/VD", align: "center", value:"percAjusteVmrOuVd" },
        { text: "TIPO DE FRANQUIA", align: "center", value:"tipoDeFranquia" },
        { text: "VLR. FIPE", align: "center", value:"valorFipe" },
        { text: "VD CONTRATADO", align: "center", value:"vdContratado" },
        { text: "DANOS MATERIAIS", align: "center", value:"danosMateriais" },
        { text: "VLR. FRANQUIA DM", align: "center", value:"vlrFranquiaDanosMateriais" },
        { text: "DANOS CORPORAIS", align: "center", value:"danosCorporais" },
        { text: "DANOS MORAIS E ESTÉTICOS", align: "center", value:"danosMoraisEEsteticos" },
        { text: "GARANTIA ÚNICA", align: "center", value:"garantiaUnica" },
        { text: "VLR. GARANTIA ÚNICA", align: "center", value:"vlrGarantiaUnica" },
        { text: "VLR. FRANQUIA GU", align: "center", value:"vlrFranquiaGarantiaUnica" },
        { text: "APP MORTE", align: "center", value:"appMorte" },
        { text: "APP INVALIDEZ", align: "center", value:"appInvalidez" },
        {
          text: "DMHO",
          align: "center",
          value:"despesasMedicasHospitalaresEOdontologicas",
          tool: "DESP. MÉDICAS, HOSPITALARES E ODONTOLÓGICAS"
        },
        {
          text: "AD. DESP. EXTRA",
          align: "center",
          value:"coberturaAdicionalDespesasExtras",
          tool: "COBERTURA ADICIONAL: DESPESAS EXTRAS"
        },
        { text: "DESPESAS EXTRAS", align: "center", value:"despesasExtras" },
        { text: "CAMINHÃO BASCULADO", align: "center", value:"caminhaoBasculado" },
        { text: "DIAS DE GARANTIA ZERO KM", align: "center", value:"diasGarantZeroKm" },
        {
          text: "COMPREENSIVA: TUMULTOS",
          align: "center",
          value:"garantiaCompreensivaParaTumultos",
          tool: "GARANTIA COMPREENSIVA PARA TUMULTOS"
        },
        { text: "RCF - EXT. COB. AMÉRICA DO SUL",
          align: "center",
          value:"rcfExtCobAmericaDoSul",
          tool: "RCF - EXT. DE PERÍMETRO PARA AMÉRICA DO SUL"
        },
        { text: "VLR. RCF - EXT. COB. AMÉRICA DO SUL", align: "center", value:"vlrRcfExtCobAmericaDoSul" },
        {
          text: "DANOS MAT. DIRIGENTES ETC",
          align: "center",
          value:"danosMateriaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS MATERIAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS"
        },
        {
          text: "DANOS CORP. DIRIGENTES ETC",
          align: "center",
          value:"danosCorporaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS CORPORAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS"
        },
        {
          text: "VLR. DANOS CORP. DIRIGENTES ETC",
          align: "center",
          value:"vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos",
          tool: "VLR. DANOS CORP. DIRIGENTES ETC"
        },
        { text: "GU DM/DC DIRIGENTES ETC", value: "guDmDcADirigentesSociosEmpregadosEPrepostos" },
        { text: "VLR. GU DM/DC DIRIGENTES ETC", value: "vlrGuDmDcADirigentesSociosEmpregadosEPrepostos" },
        {
          text: "DANOS A TERCEIROS",
          value: "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado",
          tool: "DANOS MATERIAIS/CORPORAIS, CAUSADO POR REBOQUE/SEMIRREBOQUE DESATRELADO"
        },
        {
          text: "EXT. RCF VEÍC. REBOCADOS",
          align: "center",
          value:"extensaoDeCoberturaRcfAVeiculosRebocados",
          tool: "EXTENSÃO DE COBERTURA RCF A VEÍCULOS REBOCADOS"
        },
        {
          text: "VLR. EXT. RCF VEÍC. REBOCADOS",
          align: "center",
          value:"vlrExtensaoDeCoberturaRcfAVeiculosRebocados"
        },
        {
          text: "AD. CARROCERIA",
          align: "center",
          value:"coberturaAdicionalCarroceria",
          tool: "COBERTURA ADICIONAL: CARROCERIA"
        },
        { text: "DESCR. DA CARROCERIA", align: "center", value:"descriCarroceria" },
        { text: "VLR. CARROCERIA", align: "center", value:"vlrCarroceria" },
        {
          text: "VLR. DANOS MAT. DIRIGENTES ETC",
          align: "center",
          value:"vlrDmDirigenteSociosEmpregadosPrepostos"
        },
        {
          text: "AD. EQUIPAMENTOS",
          align: "center",
          value:"coberturaAdicionalEquipamentos",
          tool: "COBERTURA ADICIONAL: EQUIPAMENTOS"
        },
        { text: "DESCR. DO EQUIPAMENTO", align: "center", value:"descEquipamentos" },
        { text: "VLR. EQUIPAMENTO", align: "center", value:"vlrEquipamentos" },
        {
          text: "AD. ACESSÓRIOS",
          align: "center",
          value:"coberturaAdicionalAcessorios",
          tool: "COBERTURA ADICIONAL: ACESSÓRIOS"
        },
        { text: "DESCR. DO ACESSÓRIO", align: "center", value:"descAcessorios" },
        { text: "VLR. ACESSÓRIO", align: "center", value:"vlrAcessorios" },
        { text: "VLR. BLINDAGEM", align: "center", value:"vlrBlindagem" },
        { text: "VLR. KIT GÁS", align: "center", value:"vlrKitGas" },
        { text: "KM ASSISTÊNCIA", align: "center", value:"kmAssistencia" },
        { text: "CARROS RESERVA", align: "center", value:"carroReserva" },
        { text: "COBERTURA VIDROS", align: "center", value:"coberturaVidros" },
        { text: "TIPO DE PROPOSTA", align: "center", value:"tipoDeProposta" },
        { text: "CLASSE", align: "center", value:"classeBonus" },
        { text: "Nº APÓLICE ANTERIOR", align: "center", value:"numeroApoliceAnterior" },
        { text: "Nº ANTERIOR", align: "center", value:"numeroItemAnterior" },
        { text: "TIPO DE RENOVAÇÃO", align: "center", value:"renovacaoComSinistro" },
        { text: "CIA. RENOVAÇÃO", align: "center", value:"ciaRenovacao" },
        { text: "CÓD. RENOVAÇÃO", align: "center", value:"codRenovacao" },
        { text: "DESP. SALV. CONTENÇÃO SINISTRO", value: "despesasSalvamentoContencaoSinistro" },
        { text: "VLR. DESP. SALV. CONTENÇÃO SINISTRO", value: "vlrDespesasSalvamentoContencaoSinistro" },
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogCalculo: false,
      pagination: {
        sortBy: "name",
        totalPages: null,
        rowsPerPage: 10,
        page: 1
      },
      selected: [],
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        }
      },
      idPropostaStatus: null,
      idApolice: null,
      camposInfoGerais: {
        formaPagamentoList: [],
        idFormaPagamento: null,
        parcelamentoList: [],
        idParcelamento: null,
        dataPrimeiraParcela: null,
        apoliceIof: null,
        corretagem: null
      }
    };
  },
  computed: {
    ...mapState("formEndosso", ["itemRemovidoList"]),

    camposDisabled() {
      if (this.idStatusEndosso == 1) {
        return false;
      } else if (this.idStatusEndosso == 8) {
        return false;
      } else if (!this.idStatusEndosso) {
        return false;
      } else {
        return true;
      }
    },
    botaoVerCalculo() {
      this.numeroRevisao = parseInt(this.$route.query.numeroRevisao);
      this.idStatusEndosso = parseInt(this.$route.query.idStatusEndosso);
      return this.idStatusEndosso == 1 && this.numeroRevisao;
    },

    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },
    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },

    textPrimeiraParcela() {
      return new Date(this.calculoDataPrimeiraParcela).toLocaleDateString(
        "pt-BR",
        {
          timeZone: "UTC",
          year: "numeric",
          month: "long",
          day: "numeric"
        }
      );
    }
  },
  watch: {
    pagination() {
      this.buscarVeiculosParaExclusao();
    },
    idItemRemovidoList() {
      this.buscarVeiculosParaExclusao();
    }
  },
  mounted() {
    this.recalcular = this.$store.getters[
      "formEndosso/infoEndosso"
    ].recalcular;
    this.numeroRevisao = parseInt(this.$route.query.numeroRevisao);
    this.idStatusEndosso = parseInt(this.$route.query.idStatusEndosso);
    this.idRascunhoEndosso = this.$route.query.idRascunhoEndosso;
    this.idMotivoEndosso = localStorage.getItem("idMotivoEndosso");
    this.textoLivreEndosso = localStorage.getItem("textoLivreEndosso");
    this.dateInicio = localStorage.getItem("dateInicio");
    this.idTipoEndosso = this.$route.query.idTipoEndosso;
    this.idApolice = parseInt(this.$route.query.id);
    this.idPropostaStatus = this.$route.query.idPropostaStatus
      ? this.$route.query.idPropostaStatus
      : null;
    if (this.idRascunhoEndosso == undefined) {
      this.veiculoList = this.$store.getters[
        "formEndosso/cloneConteudoPlanilha"
      ];
    }
    this.buscarVeiculosParaExclusao(this.numeroRevisao);
    if(this.idApolice && idTipoEndosso == 3) {
      this.listarItemRemovidos();
    }
  },

  methods: {
    cancelar() {
      this.coberturaExcluirList = [];
      this.modalCobertura = false;
    },
    coberturaAdicionadaAExclusao(item) {
      for (var cobertura of this.coberturaExcluirList) {
        if (cobertura == item) {
          return true;
        }
      }
    },
    atualizarItensASerExcluidos() {
      if (this.itemModificadoList.length > 0) {
        for (var itemModificado of this.itemModificadoList) {
          if (this.selected[0].item == itemModificado.item) {
            delete itemModificado.item;
            for (var key of Object.values(itemModificado)) {
              this.coberturaExcluirList.push(key);
            }
          }
        }
      }
    },
    salvar() {
      let itensSalvar = [];
      let itemExcluir = { item: this.selected[0]["item"] };

      for (var cobertura of this.coberturaExcluirList) {
        itemExcluir[cobertura] = this.selected[0][cobertura];

        if (Number.isInteger(itemExcluir[cobertura]) == true) {
          itemExcluir[cobertura] = 0;
        } else if (itemExcluir[cobertura] == true) {
          itemExcluir[cobertura] = false;
        } else if (cobertura === "tipoCobertura") {
          itemExcluir[cobertura] = 3;
        } else if (cobertura === "kmAssistencia") {
          itemExcluir[cobertura] = { id: 0 };
        } else if (itemExcluir[cobertura] !== 0) {
          itemExcluir[cobertura] = 0;
        }
      }
      itensSalvar.push(itemExcluir);
      this.itemModificadoList.push(itemExcluir);
      this.modalCobertura = false;
      this.coberturaExcluirList = [];
    },

    getTextItem(itemValue) {
      let itemValuReturn = {};
      for (let item of this.headers) {
        if (itemValue != null && item.value == itemValue) {
          itemValuReturn = item.text;
          break;
        }
      }
      return itemValuReturn;
    },
    carregarTipoCobertura(tipoCobertura) {
      var item = {};
      if (tipoCobertura === "Compreensiva") {
        item.nome = "COBERTURA COMPREENSIVA";
        item.id = 1;
        return item;
      } else if (tipoCobertura === "Incêndio e Roubo") {
        item.nome = "COBERTURA INCÊNDIO E ROUBO";
        item.id = 2;
        return item;
      } else if (tipoCobertura === "RCF") {
        item.nome = "COBERTURA RCF";
        item.id = 3;
        return item;
      } else if (tipoCobertura === "Compreensiva + RCF") {
        item.nome = "COBERTURA COMPREENSIVA + RCF";
        item.id = 4;
        return item;
      }
    },
    loadCoberturasByItemSelected() {
      let coberturasByItem = [];
      if (this.selected.length > 0 && this.modalCobertura == true) {
        if (this.selected[0]["tipoCobertura"] !== "RCF") {
          var tipoCobertura = this.carregarTipoCobertura(
            this.selected[0].tipoCobertura
          );
          coberturasByItem.push({
            text: tipoCobertura.nome,
            value: this.selected[0].tipoCobertura,
            id: "tipoCobertura"
          });
        }
        if (
          this.selected[0].appMorte !== "Nenhum" &&
          this.selected[0].appMorte
        ) {
          coberturasByItem.push({
            text: this.getTextItem("appMorte"),
            value: this.selected[0]["appMorte"],
            id: "appMorte"
          });
        }
        if (this.selected[0]["caminhaoBasculado"] == true) {
          coberturasByItem.push({
            text: this.getTextItem("caminhaoBasculado"),
            value: this.selected[0]["caminhaoBasculado"],
            id: "caminhaoBasculado"
          });
        }
        if (this.selected[0]["renovacaoComSinistro"] == true) {
          coberturasByItem.push({
            text: this.getTextItem("renovacaoComSinistro"),
            value: this.selected[0]["renovacaoComSinistro"],
            id: "renovacaoComSinistro"
          });
        }
        if (this.selected[0]["danosMateriais"]) {
          coberturasByItem.push({
            text: this.getTextItem("danosMateriais"),
            value: this.selected[0]["danosMateriais"],
            id: "danosMateriais"
          });
        }
        if (this.selected[0]["danosCorporais"]) {
          coberturasByItem.push({
            text: this.getTextItem("danosCorporais"),
            value: this.selected[0]["danosCorporais"],
            id: "danosCorporais"
          });
        }
        if (this.selected[0]["danosMoraisEEsteticos"]) {
          coberturasByItem.push({
            text: this.getTextItem("danosMoraisEEsteticos"),
            value: this.selected[0]["danosMoraisEEsteticos"],
            id: "danosMoraisEEsteticos"
          });
        }
        if (this.selected[0]["appInvalidez"] != null) {
          coberturasByItem.push({
            text: this.getTextItem("appInvalidez"),
            value: this.selected[0]["appInvalidez"],
            id: "appInvalidez"
          });
        }
        if (this.selected[0]["despesasMedicasHospitalaresEOdontologicas"]) {
          coberturasByItem.push({
            text: this.getTextItem("despesasMedicasHospitalaresEOdontologicas"),
            value: this.selected[0][
              "despesasMedicasHospitalaresEOdontologicas"
            ],
            id: "despesasMedicasHospitalaresEOdontologicas"
          });
        }
        if (this.selected[0]["coberturaAdicionalDespesasExtras"] == true) {
          coberturasByItem.push({
            text: this.getTextItem("coberturaAdicionalDespesasExtras"),
            value: this.selected[0]["coberturaAdicionalDespesasExtras"],
            id: "coberturaAdicionalDespesasExtras"
          });
        }
        if (this.selected[0]["despesasExtras"]) {
          coberturasByItem.push({
            text: this.getTextItem("despesasExtras"),
            value: this.selected[0]["despesasExtras"],
            id: "despesasExtras"
          });
        }
        if (this.selected[0]["garantiaCompreensivaParaTumultos"] == true) {
          coberturasByItem.push({
            text: this.getTextItem("garantiaCompreensivaParaTumultos"),
            value: this.selected[0]["garantiaCompreensivaParaTumultos"],
            id: "garantiaCompreensivaParaTumultos"
          });
        }
        if (
          this.selected[0][
            "rcfExtCobAmericaDoSul"
          ] == true
        ) {
          coberturasByItem.push({
            text: this.getTextItem(
              "rcfExtCobAmericaDoSul"
            ),
            value: this.selected[0][
              "rcfExtCobAmericaDoSul"
            ],
            id: "rcfExtCobAmericaDoSul"
          });
        }
        if (
          this.selected[0][
            "danosMateriaisADirigentesSociosEmpregadosEPrepostos"
          ] == true
        ) {
          coberturasByItem.push({
            text: this.getTextItem(
              "danosMateriaisADirigentesSociosEmpregadosEPrepostos"
            ),
            value: this.selected[0][
              "danosMateriaisADirigentesSociosEmpregadosEPrepostos"
            ],
            id: "danosMateriaisADirigentesSociosEmpregadosEPrepostos"
          });
        }
        if (
          this.selected[0][
            "danosCorporaisADirigentesSociosEmpregadosEPrepostos"
          ] == true
        ) {
          coberturasByItem.push({
            text: this.getTextItem(
              "danosCorporaisADirigentesSociosEmpregadosEPrepostos"
            ),
            value: this.selected[0][
              "danosCorporaisADirigentesSociosEmpregadosEPrepostos"
            ],
            id: "danosCorporaisADirigentesSociosEmpregadosEPrepostos"
          });
        }
        if (
          this.selected[0][
            "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado"
          ]
        ) {
          coberturasByItem.push({
            text: this.getTextItem(
              "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado"
            ),
            value: this.selected[0][
              "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado"
            ],
            id:
              "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado"
          });
        }
        if (
          this.selected[0]["extensaoDeCoberturaRcfAVeiculosRebocados"] == true
        ) {
          coberturasByItem.push({
            text: this.getTextItem("extensaoDeCoberturaRcfAVeiculosRebocados"),
            value: this.selected[0]["extensaoDeCoberturaRcfAVeiculosRebocados"],
            id: "extensaoDeCoberturaRcfAVeiculosRebocados"
          });
        }
        if (this.selected[0]["coberturaAdicionalCarroceria"] == true) {
          coberturasByItem.push({
            text: this.getTextItem("coberturaAdicionalCarroceria"),
            value: this.selected[0]["coberturaAdicionalCarroceria"],
            id: "coberturaAdicionalCarroceria"
          });
        }
        if (this.selected[0]["coberturaAdicionalEquipamentos"] == true) {
          coberturasByItem.push({
            text: this.getTextItem("coberturaAdicionalEquipamentos"),
            value: this.selected[0]["coberturaAdicionalEquipamentos"],
            id: "coberturaAdicionalEquipamentos"
          });
        }
        if (this.selected[0]["coberturaAdicionalAcessorios"] == true) {
          coberturasByItem.push({
            text: this.getTextItem("coberturaAdicionalAcessorios"),
            value: this.selected[0]["coberturaAdicionalAcessorios"],
            id: "coberturaAdicionalAcessorios"
          });
        }
        if (
          this.selected[0]["kmAssistencia"] !== "Nenhum" &&
          this.selected[0]["kmAssistencia"]
        ) {
          coberturasByItem.push({
            text: this.getTextItem("kmAssistencia"),
            value: this.selected[0]["kmAssistencia"],
            id: "kmAssistencia"
          });
        }
        if (this.selected[0]["carroReserva"] != null) {
          coberturasByItem.push({
            text: this.getTextItem("carroReserva"),
            value: this.selected[0]["carroReserva"],
            id: "carroReserva"
          });
        }
        if (this.selected[0]["coberturaVidros"]) {
          coberturasByItem.push({
            text: this.getTextItem("coberturaVidros"),
            value: this.selected[0]["coberturaVidros"],
            id: "coberturaVidros"
          });
        }
        if (this.selected[0]["garantiaUnica"]) {
          coberturasByItem.push({
            text: this.getTextItem("garantiaUnica"),
            value: this.selected[0]["garantiaUnica"],
            id: "garantiaUnica"
          });
        }
        if (this.selected[0]["vlrKitGas"]) {
          coberturasByItem.push({
            text: this.getTextItem("vlrKitGas"),
            value: this.selected[0]["vlrKitGas"],
            id: "vlrKitGas"
          });
        }
        if (this.selected[0]["vlrBlindagem"]) {
          coberturasByItem.push({
            text: this.getTextItem("vlrBlindagem"),
            value: this.selected[0]["vlrBlindagem"],
            id: "vlrBlindagem"
          });
        }
        this.coberturasItens = coberturasByItem;
        return coberturasByItem;
      }
    },

    buscarPlaca() {
      if (this.selected.length > 0) {
        this.selected[0].placa;
        return this.selected[0].placa;
      }
    },
    aplicarModificacoes() {
      const modificados = this.$store.state.formEndosso.itemModificadoList;
      modificados.forEach(e => this.adicionarModificacao(e));
    },
    adicionarModificacao(itemModificado) {
      if (itemModificado) {
        const buscaEditado = this.veiculoList.find(
          e => itemModificado.item === e.item
        );
        if (buscaEditado) {
          buscaEditado.modificacoes = itemModificado;
        }
      }
    },
    getTipoEndosso(idTipoEndosso) {
      if (idTipoEndosso == 1) return "COBRANÇA";
      else if (idTipoEndosso == 2) return "EXCLUSÃO";
      else if (idTipoEndosso == 3) return "SEM MOVIMENTAÇÃO";
      else if (idTipoEndosso == 4) return " CANCELAMENTO";
    },

    totaisCalculados() {
      const totais = this.$store.getters["formEndosso/totais"]
      if(totais == null ||totais.totalPremio == 0 ||totais.totalPremio == null || this.recalcular ) {
        this.solicitaCalculo();

        return this.resultados
      }

      this.resultados = {...totais};
      this.dialogCalculo = true;
    },
    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "numeric",
        day: "numeric"
      });
    },
    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },

    buscarTitulo(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          item => item.id === entity || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    comparador(itemLista, item) {
      if (item && item.id !== null && item.id !== undefined) {
        return item.id === itemLista.id;
      }
      return false;
    },

    abrirModalCobertura() {
      this.atualizarItensASerExcluidos();
      const selecionado = this.selected.map(e => e.item);
      this.itemSelecionado = this.veiculoList.filter(
        e => !selecionado.includes(e.item)
      );
      const ativos = this.itemSelecionado.filter(
        e => this.itemSelecionado[e] !== null
      );
      this.modalCobertura = true;
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dadosPlanilha.slice();
    },
    filtroFunctions: function() {
      const self = this;
      return {
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        }
      };
    },

    storageItemModificado() {
      var veiculoModificadoList = {
        dados: this.itemModificadoList
      };
      this.$store.commit(
        "formEndosso/setItensModificados",
        veiculoModificadoList
      );
    },

    listarItemRemovidos() {
      var itensExclusao = this.$store.getters["formEndosso/dadosItemExclusao"];
      for (var i = 0; i < itensExclusao.itemRemovidoList.length; i++) {
        if (this.listaIdItem[i] != itensExclusao.itemRemovidoList[i].item) {
          this.listaIdItem.push(itensExclusao.itemRemovidoList[i].item);
        }
      }
      itensExclusao.forEach(item => this.listaIdItem.push(item));
      return this.listaIdItem;
    },

    solicitaCalculo() {
      this.loaderPagina = true;
      var dadosEndosso = this.$store.getters["formEndosso/dadosEndosso"];
      const dadosAtualizados = {
        dateInicio: dadosEndosso.dateInicio,
        itemRemovidoList: [
          ...new Set(
            [
              ...this.itemRemovidoList,
              ...this.veiculoRemovidoList.map(v => v.item)
            ].filter(v => v !== null && v !== undefined)
          )
        ],
        itemModificadoList: this.itemModificadoList,
        idTipoEndosso: dadosEndosso.idTipoEndosso,
        idAplicaCondicao: dadosEndosso.idAplicaCondicao
      };
      this.storageItemModificado();
      axios
        .post(
          `${process.env.URL_ENDOSSOMS}/v1/calcularEndosso/${this.idApolice}`,
          dadosAtualizados,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.loaderPagina = false;
          Object.keys(this.resultados).forEach(item => {
            this.resultados[item] = response.data[item];
            this.aplicarModificacoes();
          });
          this.dialogCalculo = true;
        })
        .catch(error => {
          this.loaderPagina = false;
          this.snack = true;
          this.snackColor = "error";
          error.response.data.message
            ? (this.snackText = error.response.data.message)
            : (this.snackText = "generico");
        });
    },
    colunas(item) {
      return [
        [this.formatarNumeroItem(item.item), { class: "pa-4 text-align-center" }],
        [item.placa || '-', { class: "text-align-center" }],
        [item.tipoCobertura || '-', { class: "pa-4 text-align-center" }],
        [item.tipoDeContratacao  || '-', { class: "pa-4 text-align-center" }],
        [item.percAjusteVmrOuVd || '-', { class: "text-align-center" }],
        [item.tipoDeFranquia || '-', { class: "text-align-center" }],
        [this.formatMoney(item.valorFipe), { class: "text-align-center" }],
        [this.formatMoney(item.vdContratado), { class: "text-align-center" }],
        [this.formatMoney(item.danosMateriais), { class: "text-align-center" }],
        [this.formatMoney(item.vlrFranquiaDanosMateriais), { class: "text-align-center" }],
        [this.formatMoney(item.danosCorporais), { class: "text-align-center" }],
        [this.formatMoney(item.danosMoraisEEsteticos), { class: "text-align-center" }],
        [this.traduzValor(item.garantiaUnica), { class: "text-align-center" }],
        [this.formatMoney(item.vlrGarantiaUnica), { class: "text-align-center" }],
        [this.formatMoney(item.vlrFranquiaGarantiaUnica), { class: "text-align-center" }],
        [this.formatMoney(item.appMorte), { class: "text-align-center" }],
        [this.formatMoney(item.appInvalidez), { class: "text-align-center" }],
        [this.formatMoney(item.despesasMedicasHospitalaresEOdontologicas), { class: "text-align-center" }],
        [this.traduzValor(item.coberturaAdicionalDespesasExtras), { class: "text-align-center" }],
        [this.formatMoney(item.despesasExtras), { class: "text-align-center" }],
        [this.traduzValor(item.caminhaoBasculado), { class: "text-align-center" }],
        [item.diasGarantZeroKm  || '-', { class: "text-align-center" }],
        [this.traduzValor(item.garantiaCompreensivaParaTumultos), { class: "text-align-center" }],
        [
          this.traduzValor(
            item.rcfExtCobAmericaDoSul
          ),
          { class: "text-align-center" }
        ],
        [
          this.formatMoney(
            item.vlrRcfExtCobAmericaDoSul
          ),
          { class: "text-align-center" }
        ],
        [
          this.traduzValor(
            item.danosMateriaisADirigentesSociosEmpregadosEPrepostos
          ),
          { class: "text-align-center" }
        ],
        [
          this.traduzValor(
            item.danosCorporaisADirigentesSociosEmpregadosEPrepostos
          ),
          { class: "text-align-center" }
        ],
        [
          this.formatMoney(
            item.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
          ),
          { class: "text-align-center" }
        ],
        [
          this.traduzValor(
            item.guDmDcADirigentesSociosEmpregadosEPrepostos
          ),
          { class: "text-align-center" }
        ],
        [
          this.formatMoney(
            item.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos
          ),
          { class: "text-align-center" }
        ],
        [
          this.traduzValor(
            item.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
          ),
          { class: "text-align-center" }
        ],
        [this.traduzValor(item.extensaoDeCoberturaRcfAVeiculosRebocados), { class: "text-align-center" }],
        [this.traduzValor(item.coberturaAdicionalCarroceria), { class: "text-align-center" }],
        [item.descriCarroceria  || '-', { class: "text-align-center" }],
        [
          this.formatMoney(item.vlrExtensaoDeCoberturaRcfAVeiculosRebocados),
          { class: "text-align-center" }
        ],
        [this.formatMoney(item.vlrCarroceria), { class: "text-align-center" }],
        [this.traduzValor(item.coberturaAdicionalEquipamentos), { class: "text-align-center" }],
        [this.formatMoney(item.vlrDmDirigenteSociosEmpregadosPrepostos), { class: "text-align-center" }],
        [item.descEquipamentos  || '-', { class: "text-align-center" }],
        [this.formatMoney(item.vlrEquipamentos), { class: "text-align-center" }],
        [this.traduzValor(item.coberturaAdicionalAcessorios), { class: "text-align-center" }],
        [item.descAcessorios  || '-', { class: "text-align-center" }],
        [this.formatMoney(item.vlrAcessorios), { class: "text-align-center" }],
        [this.formatMoney(item.vlrBlindagem), { class: "text-align-center" }],
        [this.formatMoney(item.vlrKitGas), { class: "text-align-center" }],
        [item.kmAssistencia  || '-', { class: "text-align-center" }],
        [item.carroReserva || '-', { class: "text-align-center" }],
        [item.coberturaVidros  || '-', { class: "text-align-center" }],
        [item.tipoDeProposta  || '-', { class: "text-align-center" }],
        [item.classeBonus  || '-', { class: "text-align-center" }],
        [item.numeroApoliceAnterior  || '-', { class: "text-align-center" }],
        [item.numeroItemAnterior  || '-', { class: "text-align-center" }],
        [this.traduzValorSinistro(item.renovacaoComSinistro), { class: "text-align-center" }],
        [item.ciaRenovacao  || '-', { class: "text-align-center" }],
        [item.codRenovacao  || '-', { class: "text-align-center" }],
        [this.traduzValor(item.despesasSalvamentoContencaoSinistro) || '-', { class: "text-align-center" }],
        [this.formatMoney(item.vlrDespesasSalvamentoContencaoSinistro) || '-', { class: "text-align-center" }],
      ];
    },

    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    traduzValorSinistro(value) {
      if (value === true) {
        return (value = "Com Sinistro");
      } else {
        return (value = "Sem Sinistro");
      }
    },

    async buscarVeiculosParaExclusao() {
      this.loading = true;
      this.$store.commit("startLoading");
      await axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/listarVeiculos/${this.idApolice}` +
              `?page=${this.pagination.page - 1}` +
              `&size=${this.pagination.rowsPerPage}` +
              `&ignore=${this.itemRemovidoList.join(",")}` +
              (this.idTipoEndosso ? `&idTipoEndosso=${this.idTipoEndosso}` : '') +
              (this.numeroRevisao ? `&numeroRevisaoEndosso=${this.numeroRevisao}` : ''),
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          var dadosExcl = this.$store.getters["formEndosso/dadosItemExclusao"].itemRemovidoList;
          var itensRestantes = this.$store.getters["formEndosso/dadosItensRestantes"].itensRestantes;

          const veiculos = response.data.content;

          this.veiculoRemovidoList = dadosExcl;

          const veiculoFiltro = veiculos.filter(
            item => item.itemEndossoRemovido !== true
          );

          const itensJaExistentes = new Set(
            veiculoFiltro.map(v => v.item)
          );

          itensRestantes.forEach(item => {
            if (!itensJaExistentes.has(item.item)) {
              veiculoFiltro.push(item);
            }
          });

          this.veiculoList = itensRestantes;
          this.veiculoList.forEach(item => {item.itemEndossoRemovido = false});

          this.pagination.totalItems = response.data.totalElements;

          this.buscarEndosso(this.idRascunhoEndosso, this.idRascunhoEndosso);

          this.filtroFunctions().aplicarFiltros();
          this.$store.commit("endLoading");
        })
        .catch(err => {
          this.$store.commit("endLoading");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async buscaLimitesTaxas() {
      const respostaLimitesTaxas = await axios.post(
        `${process.env.URL_CALCULOMS}/v1/limitesTaxasBasicas`,

        this.dadosPlanilha
          .filter(veiculo => veiculo.catVeiculo && veiculo.catVeiculo.id !== 6)
          .map(veiculo =>
            ["item", "fipe", "anoMod", "tipoVeiculo"].reduce((acc, cur) => {
              acc[cur] = veiculo[cur];

              return acc;
            }, {})
          ),
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      if (respostaLimitesTaxas.data) {
        this.limitesTaxasBasicas = respostaLimitesTaxas.data;
      }
    },

    validaColunas() {
      return Object.values(this.erros).every(item =>
        Object.values(item).every(subItem => subItem.erro !== true)
      );
    },

    voltar: function() {
      if (this.idRascunhoEndosso) {
        this.$router.push(
          `/GridPrincipal/GridEndossoVeiculoExclusao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idRascunhoEndosso=${this.idRascunhoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else if (
        this.idRascunhoEndosso == undefined &&
        this.idStatusEndosso == 1
      ) {
        this.$router.push(
          `/GridPrincipal/GridEndossoVeiculoExclusao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idStatusEndosso=${this.idStatusEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      } else {
        this.$router.push(
          `/GridPrincipal/GridEndossoVeiculoExclusao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      }
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Editar cancelado";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Editar aberto";
    },
    close() {
      console.log("Dialog closed");
    },

    limiteExcedido({ min, max }, value) {
      return +value !== 0 && (value < min || value > max);
    },
    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    }
  }
};
</script>

<style scoped>
  .background {
    background-color: white;
  }

  .item-primary .v-menu__activator {
    display: flex;
    justify-content: center;
    text-align: center !important;
  }

  .item-color > div > a {
    color: #757575 !important;
  }

  .errorTaxa {
    color: red !important;
    font-weight: bold;
  }

  .button-permanecer {
    background: #00456e;
    color: #fff !important;
  }

  .text-permanecer {
    font-weight: bold;
    color: #757575 !important;
  }

  .headline {
    color: #fff;
    font-size: 14px !important;
  }

  .dialog {
    background: #eaeaea !important;
  }

  .textred {
    color: red;
    font-weight: 700;
  }

  .textblack {
    color: rgba(0, 0, 0, 0.7);
  }

  .textlabel {
    color: rgba(0, 0, 0, 0.7);
    font-weight: 700;
  }

  .text-align-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/CoberturaEndossoExclusao.vue